import * as React from 'react';
import PropTypes from 'prop-types';
import Icon from "../../../../common/Icon/Icon";
import { ReactComponent as Infographic } from './../../../../../images/infographics.svg';
import { ReactComponent as Graphic } from './../../../../../images/graphic.svg';

import * as styles from './DataItem.module.scss';

const DataItem = ({ title, text, type }) => (
  <div className={styles.root}>
    {type === 'splineChart' ?
      <Icon component={Infographic} /> :
      <Icon component={Graphic} />
    }
    <div className={styles.container}>
      <span className={styles.title}>{title}</span>
      <span className={styles.text}>Number of</span>
      <span className={styles.text}>{text}</span>
      <div className={styles.divider}/>
    </div>
  </div>
);

DataItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default DataItem;
